(function() {
    'use strict';

    angular
        .module('app.accionesPersonal')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/acciones-personal',
                config: {
                    templateUrl: 'app/accionesPersonal/accionesPersonal.html',
                    controller: 'AccionesPersonal',
                    controllerAs: 'vm',
                    title: 'AccionesPersonal'
                }
            },
            {
                url: '/editar-accion-personal/:id?',
                config: {
                    templateUrl: 'app/accionesPersonal/editarAccionPersonal.html',
                    controller: 'EditarAccionPersonal',
                    controllerAs: 'vm',
                    title: 'EditarAccionPersonal'
                }
            }
        ];
    }
})();
